"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authRoutes = void 0;
exports.authRoutes = [
    {
        name: 'auth.login',
        path: '/login',
        method: 'POST'
    },
    {
        name: 'auth.register',
        path: '/register',
        method: 'POST'
    },
    {
        name: 'auth.check',
        path: '/check',
        method: 'POST'
    },
    {
        name: 'auth.api-authorize',
        path: '/authorize',
        method: 'POST'
    },
    {
        name: 'auth.user-list',
        path: '/user-list',
        method: 'GET'
    },
    {
        name: 'auth.activate',
        path: '/activate',
        method: 'POST'
    }
];
